import { type Scope, createContextScope } from '@radix-ui/react-context'
import { useState } from 'react'
import { SnackbarContent } from './components/snackbar-content'
import { SnackbarFooter } from './components/snackbar-footer'
import { SnackbarTimeBar } from './components/snackbar-timebar'
import { SnackbarRootVariants } from './snackbar.styles'
import type { SnackbarProps } from './snackbar.types'

type SnackbarRootProps = SnackbarProps

export const DISPLAY_NAME = 'Snackbar'
const SnackbarRoot = (props: SnackbarRootProps) => {
  const {
    type,
    children,
    layout,
    duration,
    buttonLabel,
    onClickFooter,
    __scopeSnackbar,
  } = props as SnackbarScopedProps<SnackbarProps>
  const [isPaused, setPaused] = useState(false)
  return (
    <SnackbarProvider
      scope={__scopeSnackbar}
      layout={layout}
      type={type}
      buttonLabel={buttonLabel}
      onClickFooter={() => onClickFooter?.()}
      duration={duration}
      isPaused={isPaused}
      setPaused={setPaused}
    >
      <div
        className={SnackbarRootVariants({ type })}
        data-testid="snackbar-root"
      >
        {children}
      </div>
    </SnackbarProvider>
  )
}

SnackbarRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

export type SnackbarContext = SnackbarProps & {
  isPaused: boolean
  setPaused: (paused: boolean) => void
}

export type SnackbarScopedProps<P> = P & {
  __scopeSnackbar?: Scope
}

const [createSnackbarContext] = createContextScope(DISPLAY_NAME)

export const [SnackbarProvider, useSnackbarContext]: readonly [
  ProviderType<SnackbarContext>,
  (consumerName: string, scope: Scope) => SnackbarContext,
] = createSnackbarContext<SnackbarContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Snackbar = {
  Root: SnackbarRoot,
  Content: SnackbarContent,
  Footer: SnackbarFooter,
  Timebar: SnackbarTimeBar,
}
